class TSCart extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.candidateForRemove = 0;
    this.onPageShow = this.onPageShow.bind(this);
  }

  connectedCallback() {
    this.cartDrawer = document.querySelector("ts-cart-drawer");
    this.deletePopup = this.querySelector("#TSCartDelete");
    this.proceedToCheckoutButton = this.querySelector(".ts-main-cart__submit");
    this.termsCheckbox = this.querySelector("#MainCart-terms");
    this.termsError = this.querySelector("#MainCart-terms ~ [data-error]");
    this.deleteButton = this.querySelector("[data-trigger='remove-submit']");

    this.initClickEvent();
    this.initTermsCheckboxListener();
    this.updateGiftProducts();

    this.initAddressForm();

    window.addEventListener("pageshow", this.onPageShow);
  }

  onPageShow(event) {
    if (event.persisted) {
      console.log("Page was restored from cache");
      this.initCartDrawer();
    }
  }

  initCartDrawer() {
    fetch(window.routes.cart_url + "?sections=main-cart,cart-drawer").then(
      (res) =>
        res.json().then((sections) => {
          this.renderContent(sections);
        }),
    );
  }

  async renderContent(sections) {
    if (!sections["main-cart"]) return;

    const html = new DOMParser().parseFromString(
      sections["main-cart"],
      "text/html",
    );
    const newCart = html.querySelector("ts-cart");
    const selectors = [
      ".ts-main-cart__subtotal-price",
      ".ts-main-cart__content",
    ];

    this.setAttribute("data-count", newCart.dataset.count);
    this.setAttribute("data-empty", newCart.dataset.empty);

    selectors.forEach((selector) => {
      if (this.querySelector(selector) && newCart.querySelector(selector)) {
        this.querySelector(selector).innerHTML =
          newCart.querySelector(selector).innerHTML;
      }
    });

    document.querySelectorAll("[ts-cart-count]").forEach((count) => {
      count.innerText = this.dataset.count;
    });

    if (sections["cart-drawer"] && this.cartDrawer) {
      this.cartDrawer.renderContent(sections, false);
    }

    const giftUpdatedResult = await this.updateGiftProducts();
    this.toggleLoading(false);
  }

  updateQuantity(item, quantity = false) {
    console.log("Update item", item, "to quantity", quantity);
    this.toggleLoading(true);

    const itemQuantity =
      quantity !== false
        ? quantity
        : this.querySelector(`[data-line="${item}"] input[name='quantity']`)
            .value;

    const data = {
      line: item,
      quantity: parseInt(itemQuantity),
    };

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then(() => {
        fetch(window.routes.cart_url + "?sections=main-cart,cart-drawer")
          .then((res) => res.json())
          .then((sections) => {
            this.renderContent(sections);
          });
      })
      .catch((error) => console.error("Error:", error));
  }

  async updateGiftProducts() {
    const gifts = this.querySelector("[data-gifts]").dataset.gifts.split(",");
    const requests = [];
    let itemsToUpdate = [];
    let itemsToAdd = [];

    gifts.forEach((gift) => {
      const variantId = parseInt(gift.split(":")[0]);
      const quantity = parseInt(gift.split(":")[1]);

      if (this.querySelector(`[data-variant="${variantId}"]`)) {
        const item = this.querySelector(`[data-variant="${variantId}"]`);
        if (parseInt(item.dataset.quantity) != quantity) {
          itemsToUpdate.push({ id: variantId, quantity: quantity });
        }
      } else if (quantity > 0) {
        itemsToAdd.push({ id: variantId, quantity: quantity });
      }
    });

    if (itemsToUpdate.length > 0) {
      const itemsToUpdateObject = itemsToUpdate.reduce((acc, item) => {
        acc[item.id] = item.quantity;
        return acc;
      }, {});

      requests.push(
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: itemsToUpdateObject,
            sections: ["main-cart", "cart-drawer"],
            sections_url: window.location.pathname,
          }),
        }).then((response) => response.json()),
      );
    }

    if (itemsToAdd.length > 0) {
      requests.push(
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: itemsToAdd,
            sections: ["main-cart", "cart-drawer"],
            sections_url: window.location.pathname,
          }),
        }).then((response) => response.json()),
      );
    }

    if (requests.length === 0) return this.toggleLoading(false);

    this.toggleLoading(true);

    try {
      const results = await Promise.all(requests);
      if (results[0]?.sections) this.renderContent(results[0].sections);
    } catch (error) {
      console.error("Error:", error);
    }

    this.toggleLoading(false);
  }

  disableScroll(status = false) {
    if (status) {
      this.scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, this.scrollY);
    }
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const itemEl = e.target.closest("[data-line]");
        const quantityEl = e.target.closest("[data-quantity]");
        const tabBlock = e.target.closest("[data-tab]");
        const item = parseInt(itemEl ? itemEl.dataset.line : 0);

        switch (e.target.dataset.trigger) {
          case "details-open":
            this.disableScroll(true);
            itemEl
              .querySelector(".ts-main-cart__details-popup")
              .classList.add("open");
            break;
          case "details-close":
            this.disableScroll(false);
            itemEl
              .querySelector(".ts-main-cart__details-popup")
              .classList.remove("open");
            break;
          case "disclosure-toggle":
            if (tabBlock) {
              const content = e.target.nextElementSibling;

              tabBlock.classList.toggle("open");
              content.style.maxHeight = tabBlock.classList.contains("open")
                ? content.scrollHeight + "px"
                : null;
            }
            break;
          case "quantity-toggle":
            if (quantityEl) quantityEl.classList.toggle("open");
            break;
          case "quantity-select":
            if (quantityEl) {
              const activeEl = quantityEl.querySelector(".active");
              const prevQuantity = activeEl?.dataset?.value
                ? parseInt(activeEl?.dataset?.value)
                : 1;
              const newQuantity = parseInt(e.target.dataset.value);
              if (prevQuantity === newQuantity) break;
              const quantity = newQuantity - prevQuantity;
              const price = parseInt(e.target.dataset.value);
              const canBeProceeded =
                window.orderLimitPopup.isAvailableToProceed(quantity, price);

              if (canBeProceeded) {
                quantityEl.querySelector("input").value =
                  e.target.dataset.value;
                quantityEl.classList.remove("open");
                this.updateQuantity(item);
              }
            }
            break;
          case "remove-submit":
            this.disableScroll(false);
            if (this.candidateForRemove != 0) {
              this.updateQuantity(this.candidateForRemove, 0);
              this.candidateForRemove = 0;
            }
            break;
          case "remove-reset":
            this.disableScroll(false);
            this.candidateForRemove = 0;
            this.deletePopup.classList.remove("open");
            break;
          case "item-remove":
            this.disableScroll(true);
            this.candidateForRemove = item;
            this.deletePopup.classList.add("open");
            this.deleteButton.classList.remove("loading");

            //this.candidateForRemove = 0;
            //this.deletePopup.classList.remove("open");
            //setTimeout(() => {}, 5000);
            break;
        }
      }
    });
  }

  toggleLoading(status) {
    this.proceedToCheckoutButton.classList.add(
      "ts-main-cart__submit--disabled",
    );
    if (status == undefined || status === null) {
      this.isLoading = !this.isLoading;
      this.classList.toggle("loading", this.isLoading);
    } else {
      this.isLoading = status;
      this.classList.toggle("loading", status);
    }
    if (!this.isLoading) this.deleteButton.classList.remove("loading");
    else this.deleteButton.classList.add("loading");

    if (!this.isLoading) this.deletePopup.classList.remove("open");

    if (this.termsCheckbox.checked && !this.isLoading)
      this.proceedToCheckoutButton.classList.remove(
        "ts-main-cart__submit--disabled",
      );
  }

  initAddressForm() {
    const params = new URLSearchParams(window.location.search);
    const addressFormCheckoutPopup = document.getElementById(
      "address_form_checkout",
    );
    if (params.get("checkout") && addressFormCheckoutPopup)
      addressFormCheckoutPopup.open();
  }
  initTermsCheckboxListener() {
    if (
      !this.termsCheckbox ||
      !this.proceedToCheckoutButton ||
      !this.termsError
    )
      return;

    const updateCheckoutState = () => {
      if (this.isLoading) return;

      this.termsError.classList.toggle("show", !this.termsCheckbox.checked);
      this.proceedToCheckoutButton.classList.toggle(
        "ts-main-cart__submit--disabled",
        !this.termsCheckbox.checked,
      );
    };
    updateCheckoutState();

    this.termsCheckbox.addEventListener("click", updateCheckoutState);

    this.proceedToCheckoutButton.addEventListener("click", (e) => {
      //if (this.termsCheckbox.checked) return;
      // const addressFormCheckoutPopup = document.getElementById(
      //   "address_form_checkout",
      // );
      // if (addressFormCheckoutPopup)
      //   posthog.onFeatureFlags(() => {
      //     const v = posthog.getFeatureFlag("address-form-before-checkout");
      //     posthog.capture("checkout-clicked");
      //     if (v == "variant2") {
      //       e.preventDefault();
      //       addressFormCheckoutPopup.open();
      //     } else {
      //       posthog.capture("checkout-entered", { variant: "A" });
      //     }
      //   });
    });
  }
}

customElements.define("ts-cart", TSCart);
